import { httpService as e } from "@waitroom/http-client";
import { buildApiParamsWithAuth as s } from "../helpers.es.js";
const c = {
  getById: async (a, t) => e.get(await s(`/users/id/${a}`, t)),
  getCurrent: async (a) => e.get(await s("/users/me", a)),
  update: async (a, { data: t, ...i }) => e.put(
    await s(`/users/id/${a}`, {
      ...i,
      data: {
        userData: t
      }
    })
  ),
  getSubscriptionPlan: async (a, t) => e.get(
    await s(`/users/id/${a}/plan`, {
      ...t,
      version: "v2.0"
    })
  ),
  updateSubscriptionPlanBillingCycle: async (a, t) => e.patch(
    await s(`/users/id/${a}/plan/billing-cycle`, {
      ...t,
      version: "v2.0"
    })
  ),
  reactivateSubscriptionPlan: async (a, t) => e.post(
    await s(`/users/id/${a}/plan/reactivate`, {
      ...t,
      version: "v2.0"
    })
  ),
  cancelSubscriptionPlan: async (a) => e.post(
    await s(`/users/id/${a}/plan/cancel`, {
      version: "v2.0"
    })
  ),
  updatePaymentTransaction: async (a, t) => e.get(
    await s(`/users/id/${a}/update-payment-method-transaction`, {
      ...t,
      version: "v2.0"
    })
  ),
  activateTrial: async (a, t) => e.post(
    await s(`/users/id/${a}/activate-trial`, {
      version: "v2.0",
      ...t
    })
  ),
  createCustomer: async (a, t) => e.post(
    await s(`/users/id/${a}/customer`, {
      ...t,
      version: "v2.0"
    })
  ),
  getTransactions: async (a, t) => e.get(
    await s(`/users/id/${a}/transactions`, {
      ...t,
      version: "v2.0"
    })
  ),
  getTransactionInvoice: async (a, t, i) => e.get(
    await s(`/users/${t}/transactions/${a}/invoice`, { ...i })
  ),
  getPaymentDetails: async (a, t) => e.get(
    await s(`/users/id/${a}/payment-method-details`, {
      ...t,
      version: "v2.0"
    })
  ),
  requestDelete: async () => e.delete(await s("/users/me"))
};
export {
  c as userApiService
};
